// Define aquí tu URL. 
// Para desarrollo local: "http://localhost:5000/api"
// Para producción (Git): "https://gestor-consumo-backend-n8d9.onrender.com/api"

// const API_URL = "https://gestor-consumo-backend-n8d9.onrender.com/api";
// const API_URL = "https://gestor-consumo-backend-1.onrender.com/api";
// const API_URL = "https://gestor-consumo-backend.fly.dev/api";
const API_URL = "https://gestor-consumo-backend.vercel.app/api"
export const apiFetch = async (endpoint: string, options: RequestInit = {}) => {
  // 1. Recuperar el token de la caja fuerte
  const token = localStorage.getItem("token");

  // 2. Configurar las cabeceras (Headers)
const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string>), // Forzamos el tipo aquí también
  };

  // 3. Si hay token, lo pegamos como un sello de seguridad
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers,
  };

  try {
    console.log(` [API] Petición a: ${endpoint}`);
    const response = await fetch(`${API_URL}${endpoint}`, config);

    // 4. EL GUARDIaN: Si el token venció (401) o es falso (422)
    if (response.status === 401 || response.status === 422) {
      console.error("Sesión expirada. Cerrando sesión...");
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");
      // Redirigir al login forzosamente
      window.location.href = "/login";
      return Promise.reject("Sesión expirada");
    }

    return response;
  } catch (error) {
    console.error("Error de red:", error);
    return Promise.reject(error);
  }
};